import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { PatternsComponent } from './components/develop/patterns/patterns.component';
import { LoginJwtComponent } from './components/login-jwt/login-jwt.component';
import { adminroutes } from './components/admin/admin-routing.module';
import { miarearoutes } from './components/mirarea/miarea-routing.module';
import { AuthGuard } from './guards/auth.guard';
import { helproutes } from './components/help/help-routing.module';
import { projectsanddocumentsroutes } from './components/projectsanddocuments/projectsanddocuments-routing.module';
import { zonastihlroutes } from './components/zona-stihl/zona-stihl-routing.module';
import { pointofsalesroutes } from './components/PublicityPointSale/pointofsales/pointofsales-routing.module';
import { exhibitionseventsroutes } from './components/PublicityPointSale/exhibitionsevents/exhibitonsevents-routing.module';
import { BlacklistComponent } from './components/blacklist/blacklist.component';
import { CallbackComponent } from './components/callback/callback.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent
  },
  {
    path: 'login',
    component: LoginJwtComponent
  },
  {
    path: 'blacklist/:idOrderData',
    component: BlacklistComponent
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      // { path: 'home', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule), data: { animation: 'home' } },
      {
  path: 'home',
  loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
  data: { animation: 'home', showLayer: true }
},
      { path: 'forum', loadChildren: () => import('./components/forum/forum.module').then(m => m.ForumModule), data: { animation: 'forum' }, canActivate: [AuthGuard] },
      { path: 'campaign', loadChildren: () => import('./components/PublicityPointSale/campaign/campaign.module').then(m => m.CampaignModule), data: { animation: 'campaign' }, canActivate: [AuthGuard] },
      { path: 'imagebank', loadChildren: () => import('./components/PublicityPointSale/imagebank/imagebank.module').then(m => m.ImageBankModule), data: { animation: 'imagebank' }, canActivate: [AuthGuard] },
      { path: 'adv-expense', loadChildren: () => import('./components/PublicityPointSale/advertising-expense/adv-expense.module').then(m => m.AdmAdvExpensesModule), data: { animation: 'adv-expense' }, canActivate: [AuthGuard] },
      { path: 'welcome', loadChildren: () => import('./components/bienvenido/bienvenido.module').then(m => m.BienvenidoModule), data: { animation: 'welcome' }, canActivate: [AuthGuard] },
      { path: 'social-network', loadChildren: () => import('./components/social-network/social-network.module').then(m => m.SocialNetworkModule), data: { animation: 'social-network' }, canActivate: [AuthGuard] },
      { path: 'adm', children: adminroutes },
      { path: 'myarea', children: miarearoutes },
      { path: 'help', children: helproutes },
      { path: 'projectsanddocuments', children: projectsanddocumentsroutes },
      { path: 'area-stihl', children: zonastihlroutes },
      { path: 'pointofsales', children: pointofsalesroutes },
      { path: 'exhibitionsevents', children: exhibitionseventsroutes },
      { path: 'develop/patterns', component: PatternsComponent, data: { animation: 'patterns' } }
    ]
  },
  { path: '**', redirectTo: '/home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64] // [x, y]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
